import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Select from 'react-select';
import Modal from 'react-modal';
import Loading from 'react-simple-loading';

const Duration = ({ getContractDetails }) => {
    const navigate = useNavigate();
      const params = useParams();
        const contract_id = params.contract_id;
    const [isBtn, setIsBtn] = useState(false);
    const [duration, setDuration] = useState(null);
    const [addDurationModalOpen, setAddDurationModalOpen] = useState(false);
    const [contract, setContract] = useState(null);
    

    //  const weeks = [...new Array(99)].map((each, index) => ({ label: index + 1 + " weeks", value: index + 1 }));

    const weeks = Array.from({ length: 99 }, (_, i) => ({ label: (i + 1) + " weeks", value: (i + 1) }));
    useEffect(() => {

        window.scrollTo(0, 0)

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        getContract();


    }, []);


    const getContract = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-contract-by-id/"+contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                setContract(response.data.contract);

                setDuration(response.data.contract?.duration)

                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Contract Not Found", text: error.message });

            });
    }

    const saveDuration = async (e) => {
        e.preventDefault();
        setIsBtn(true);

        if (!duration) {
            Swal.fire({ icon: "error", title: "Error", text: "Select duration" });
            setIsBtn(false)
        } else {


            await axios.post(process.env.REACT_APP_API_URL + "/save-contract-duration-by-id", {
                duration: duration.value,
                contract_id:contract_id
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setAddDurationModalOpen(false)
                        getContractDetails();
                        getContract();


                    }
                    else {
                        Swal.fire({ icon: "error", title: "Error", text: response?.data?.message });
                    }

                    setIsBtn(false)
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };



    return (
        <>

            <div className="input-box" onClick={() => setAddDurationModalOpen(true)} >

                <label className="color-light fs-14 flex-grow-1"  >{contract?.duration ? contract?.duration + " Weeks" : ""} </label>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                </svg>
            </div>

            <Modal
                isOpen={addDurationModalOpen}
                onRequestClose={() => { setAddDurationModalOpen(false) }}
                contentLabel="Add Duration"
                className="modal"
                overlayClassName="overlay"
            >
                <div className="modal-title" >
                    <div className="flex-equal justify-content-start " ></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica  color-white">Add Duration</h3>
                    <div className="flex-equal justify-content-end" >
                        <div className="icon" onClick={() => setAddDurationModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
                <form onSubmit={saveDuration} action="#"  >

                    <div className="modal-body min-height" >
                        <div className="box modal align-self-stretch"  >

                            <div className="fd-column g-18" >

                                <div className="input-container color-light fs-12" >

                                    <div className="auto-dropdown auto-input-box" >
                                        <Select id="duration" name="duration"
                                             className="react-select" classNamePrefix="react-select"
                                            values={duration && { label: duration + " weeks", value: duration } }
                                            options={weeks}
                                            placeholder="Enter duration"
                                            onChange={(d) => { setDuration(d);}
                                            }

                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer  justify-content-space-between" >
                        <button className="btn btn-secondary" type="button" onClick={() => { setAddDurationModalOpen(false) }}>Cancel</button>
                        <button className=" btn btn-primary" type="submit" disabled={isBtn}>
                            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>


                    </div>
                </form>
            </Modal>
        </>
    );
};

export default Duration;